import React, { useState } from "react";
import { TextInput, View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import Text from "@components/CustomText";
import t from "@constants/localization";
import Photo from "./Photo";
import Comment from "./Comment";
import { saveJsonData, removeJson } from "../../../utils/commonFunctions";
import { kycStyles as s, kycColors, HALF_TILE } from "./styles";

const PATH = "screens/KYCSetup/PanSection";

const PAN_NUMBER_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

const PANSection = (props) => {
  const {
    panNumber,
    setPanNumber,
    panPhoto,
    uploadPanPhoto,
    removePanPhoto,
    disablePanSection,
    verified,
    rejectionComment = null,
    testPANid = "",
    draftKey = null,
    imageHeaders = null,
  } = props;
  const [unmatched, setUnmatched] = useState(false);
  const [focused, setFocused] = useState(false);
  const { source, localUri } = panPhoto;

  const _onBlur = () => {
    setFocused(false);
    if (panNumber && panNumber.length) {
      // Persist a valid number as a user-scoped draft (draftKey is null when
      // there's no scope id → skip). Invalid → flag and drop any stale draft.
      if (PAN_NUMBER_REGEX.test(panNumber)) {
        if (draftKey) saveJsonData(draftKey, panNumber);
      } else {
        setUnmatched(true);
        if (draftKey) removeJson(draftKey);
      }
    }
  };

  const _onChangeText = (text) => {
    setUnmatched(false);
    setPanNumber(text);
  };

  return (
    <View style={s.section}>
      <Comment kycComment={rejectionComment} />
      {verified ? (
        <View style={s.verifiedRow}>
          <CheckIcon fill="rgba(0,171,89,1)" size={18} />
          <Text style={s.verifiedText}>{t(`${PATH}/PANVerified`).trim()}</Text>
        </View>
      ) : (
        <Text style={s.sectionLabel}>
          PAN
          {!disablePanSection && <Text style={s.requiredStar}>*</Text>}
        </Text>
      )}
      <View
        style={[
          s.inputBox,
          focused && s.inputBoxFocused,
          unmatched && s.inputBoxError,
          disablePanSection && s.inputBoxDisabled,
        ]}
      >
        <TextInput
          testID={testPANid}
          editable={!disablePanSection}
          style={s.inputText}
          autoCapitalize="characters"
          placeholder="ALWPG5809L"
          placeholderTextColor={kycColors.placeholder}
          onFocus={() => setFocused(true)}
          onChangeText={_onChangeText}
          onBlur={_onBlur}
          value={panNumber}
          maxLength={10}
        />
      </View>
      {unmatched ? (
        <Text style={s.errorText}>{t(`${PATH}/checkPAN`)}</Text>
      ) : null}
      <View style={{ marginTop: 12 }}>
        <Photo
          ctaText={t(`${PATH}/uploadPhoto`)}
          onUpload={uploadPanPhoto}
          onDelete={removePanPhoto}
          source={source}
          previewUri={localUri}
          imageHeaders={imageHeaders}
          disabled={disablePanSection}
          style={{ width: HALF_TILE }}
        />
      </View>
    </View>
  );
};

export default PANSection;
